import { DefaultTheme } from 'styled-components';
import { Container } from './styles';
import { ReactComponent as Verified } from '../../assets/icons/Icon-ProfileCheck.svg';

interface IProfileVerifiedProps {
  color: keyof DefaultTheme['colors'];
}

export function ProfileVerified({ color }: IProfileVerifiedProps) {
  return (
    <Container colorSVG={color}>
      <Verified />
    </Container>
  );
}
